import React from "react";

import Background from "../../../assets/cafe/cafe-bg-02.png";
import Image from "../../../assets/cafe/cafe-choice-a.png";

import GamePageLayout from "../GamePageLayout";

const CafePage3 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("lunch-1")}
    >
      역시 환경을 생각하면 텀블러지.
      <br />
      키오스크에 텀블러 옵션이
      <br />
      더 많아져야 할 텐데.
      <br />
      그런데...직원분 엄청 바빠보이네...
    </GamePageLayout>
  );
};

export default CafePage3;
